// Set SC_DISABLE_SPEEDY to true before any styled-components import to prevent CSSOM injection errors
if (typeof window !== 'undefined') {
  (window as any).SC_DISABLE_SPEEDY = true;
}

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Prevent styled-components and third-party widget errors from breaking the environment
if (typeof window !== 'undefined') {
  const ignoreErrors = [
    'styled-components',
    'CSSStyleSheet',
    'HTMLStyleElement',
    'elfsight',
    'Script error.'
  ];

  const handleError = (event: ErrorEvent) => {
    const msg = event.message || '';
    const errorStr = event.error ? String(event.error.stack || event.error) : '';
    const isTarget = ignoreErrors.some(term => msg.includes(term) || errorStr.includes(term));
    if (isTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  const handleRejection = (event: PromiseRejectionEvent) => {
    const reasonStr = event.reason ? String(event.reason.stack || event.reason) : '';
    const isTarget = ignoreErrors.some(term => reasonStr.includes(term));
    if (isTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  window.addEventListener('error', handleError, true);
  window.addEventListener('unhandledrejection', handleRejection, true);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

